export default __webpack_public_path__ + "static/media/features-2.af6a094d.gif";